module.exports = {
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "product-updates-ui",
    "version": "1"
  },
  "pageViewWithId": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string",
      "itemId": "string",
      "title": "string"
    },
    "namespace": "product-updates-ui",
    "version": "1"
  },
  "usage": {
    "name": "usage",
    "class": "usage",
    "properties": {
      "screen": "string",
      "subscreen": "string",
      "feature": "string",
      "action": "string"
    },
    "namespace": "product-updates-ui",
    "version": "1"
  },
  "interactionWithId": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "screen": "string",
      "subscreen": "string",
      "feature": "string",
      "action": "string",
      "itemId": "string"
    },
    "namespace": "product-updates-ui",
    "version": "1"
  },
  "betaEnrollmentChange": {
    "name": "beta enrollment change",
    "class": "usage",
    "properties": {
      "betaName": "string",
      "gates": "string",
      "currentState": [
        "Joined as portal",
        "Joined as user",
        "Not participating",
        "N/A (error)"
      ],
      "nextState": [
        "Joined as portal",
        "Joined as user",
        "Not participating",
        "N/A (error)"
      ]
    },
    "namespace": "product-updates-ui",
    "version": "1"
  },
  "betaRequest": {
    "name": "beta request",
    "class": "usage",
    "properties": {
      "betaName": "string",
      "gates": "string"
    },
    "namespace": "product-updates-ui",
    "version": "1"
  },
  "emailEngagementWithProductUpdateId": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "portalId": "string",
      "userId": "string",
      "productUpdateId": "string",
      "emailIdempotentId": "string"
    },
    "namespace": "product-updates-ui",
    "version": "1"
  },
  "emailEngagement": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "portalId": "string",
      "userId": "string",
      "emailIdempotentId": "string"
    },
    "namespace": "product-updates-ui",
    "version": "1"
  },
  "giveFeedbackButtonClick": {
    "name": "usage",
    "class": "usage",
    "properties": {
      "screen": "string",
      "subscreen": "string",
      "action": "string",
      "origin": "string",
      "rolloutState": "string",
      "productUpdateId": "string",
      "productUpdateTitle": "string"
    },
    "namespace": "product-updates-ui",
    "version": "1"
  },
  "giveFeedbackButtonSubmit": {
    "name": "usage",
    "class": "usage",
    "properties": {
      "screen": "string",
      "subscreen": "string",
      "action": "string",
      "origin": "string",
      "rolloutState": "string",
      "productUpdateId": "string",
      "productUpdateTitle": "string",
      "rating": "string",
      "withFeedback": "boolean",
      "handRaised": "boolean"
    },
    "namespace": "product-updates-ui",
    "version": "1"
  }
};